import i18nVue from '@/i18n/locale'
export default {
  updatePerformance(state, payload = {}) {
    state.performance = payload
  },

  updatePerformanceTabCurrent(state, payload = 0) {
    state.current = payload
  },
  updatePerfDetail(state, payload = {}) {
    state.perfDetail = payload
  },
  // getShopListFilter (state, payload = {}) {
  //   // state.filters = payload
  // },

  updateIndicatorTabs(state, payload = []) {
    state.tabs = [{ key: 0, value: i18nVue.t('Gattaran_mgt_All_SSzR' /** 全部 */) }]
      .concat(payload)
      .map(item => ({
        value: item.key,
        label: item.value,
      }))
  },

  setFilterParams(state, payload = {}) {
    for (const key in payload) {
      if (key in state.filters) {
        state.filters[key] = payload[key]
      }
    }
  },
  resetFilterParams(state) {
    const defaultFilters = {
      // 非必需
      indicatorId: 0, // 指标ID.All tab不传，其他tab必传
      shopId: 0, // 商家ID
      shopName: '', // 商家名称
      rank: [], // 商机等级
      shopLayerLevel: [], // 商家运营等级
      potential: [],
      rPerformance: [],
      // 必需
      shopRange: 1, // 商家范围 1未达标商家 2全部商家
      sort: 1, // 排序 1系统推荐 2距离排序
      pageNo: 1, // 页码
      pageSize: 20, // 默认20
      lat: 0, // 纬度
      lng: 0, // 经度
    }
    for (const key in defaultFilters) {
      state.filters[key] = defaultFilters[key]
    }
  },
}
